<template>
  <b-card>
    <b-row>
      <b-col sm="12">
        <h1>{{i18nT(`Rating templates`)}}</h1>
          <p>{{i18nT(`Create rating templates to easily rate and gather feedback from the hiring team.`)}}</p>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="mb-1 mr-1 pl-1"
          v-b-modal.modal-score-template
          @click="resetForm"
        >
          <feather-icon
            icon="PlusCircleIcon"
            class="mr-1"
          />
          {{i18nT(`Add new`)}}
        </b-button>
      </b-col>
    </b-row>
    <draggable
      v-model="ratingTemplates"
      tag="ul"
      class="list-group cursor-move"
    >
      <b-list-group-item
        v-for="(documentType, index) in ratingTemplates"
        :key="index"
        tag="li"
      >
        <div class="draggable-container">
          <div>
            <strong> {{ documentType.Label }}</strong>
          </div>
          <div class="d-flex align-items-center">
            <feather-icon
              icon="Edit2Icon"
              size="17"
              class="cursor-pointer d-sm-block d-none mr-1"
              @click="onEdit(documentType)"
            />
            <feather-icon
              icon="Trash2Icon"
              size="17"
              class="cursor-pointer d-sm-block d-none mr-1"
              @click="onDelete(documentType)"
            />
          </div>
        </div>
      </b-list-group-item>
    </draggable>
    <!-- MODAL -->
    <b-modal
      id="modal-score-template"
      :title="i18nT(`Rating template`)"
      ok-only
      :ok-title="i18nT(`Save`)"
      no-close-on-backdrop
      @ok="validationForm"
    >
      <span>{{ i18nT(`Create a rating template.`) }}</span>
      <validation-observer ref="simpleRules">
        <b-form class="mt-2">
          <b-row>

            <b-col sm="12">
              <b-form-group
                :label="i18nT(`Rating name`)"
                label-for="Rating name"
                class="required"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Rating name"
                  rules="required"
                >
                  <b-form-input
                    v-model="currentType.Label"
                    :placeholder="i18nT(`E.g. personality, skills, communication...`)"
                    name="subject"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                :label="i18nT(`Rating type`)"
                label-for="ratingType"
                class="required"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="ratingType"
                  rules="required"
                >
                  <b-form-select
                    v-model="currentType.Type"
                    :options="types"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BListGroupItem,
  BFormSelect
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import draggable from 'vuedraggable'
import { dictToSelectArray } from '@core/utils/utils'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BListGroupItem,
    draggable,
    BFormSelect
  },
  directives: {
    Ripple
  },
  props: {
    generalData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      ratingTemplates: [],
      currentType: {},
      types: []
    }
  },
  methods: {
    resetForm() {
      this.currentType = {}
    },
    validationForm(event) {
      event.preventDefault()

      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          //TODO
          const formData = new FormData()

          formData.append('Label', this.currentType.Label)
          formData.append('Type', this.currentType.Type)

          if (this.currentType) {
            formData.append('id', this.currentType.Id)
          }

          this.$http
            .post('settings/ratingTemplates', formData)
            .then(res => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.successMessage(res),
                  icon: 'InfoIcon',
                  variant: 'success'
                }
              })

              this.$bvModal.hide('modal-score-template')
              this.loadData()
              this.currentType = {}
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.errorMessage(err),
                  icon: 'AlertTriangleIcon',
                  variant: 'danger'
                }
              })
            })
        }
      })
    },
    onEdit(type) {
      this.currentType = Object.assign({}, type)

      this.$bvModal.show('modal-score-template')
    },
    onDelete(type) {
      console.log(type)
      this.$swal({
        title: this.i18nT(`Are you sure?`),
        text: this.i18nT(`You won't be able to revert this!`),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.i18nT(`Yes, delete it!`),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      }).then(({ value }) => {
        if (value) {
          this.$http
            .delete(`settings/ratingTemplates?id=${type.Id}`)
            .then(res => {
              this.loadData()
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.successMessage(res),
                  icon: 'InfoIcon',
                  variant: 'success'
                }
              })
            })
        }
      })
    },
    loadData() {
      this.$http.get(`settings/ratingTemplates`).then(({ data }) => {
        this.ratingTemplates = data.data
      })
    }
  },
  setup() {
    return {
      required
    }
  },
  created() {
    this.$http.get(`settings/ratingTemplatesTypes`).then(({ data }) => {
      this.types = dictToSelectArray(data.data)
    })
    this.loadData()
  }
}
</script>

<style lang="scss">
.draggable-container {
  display: flex;
  justify-content: space-between;
}
</style>
